import React, { useEffect, useState } from "react";
import { IoReceiptSharp } from "react-icons/io5";
import { useAuth } from "../../hooks/GlobalProvider";
import { API_KEY, CRUDadmin } from "../../hooks/APIHooks";
import { Link } from "react-router-dom";
import LogoLoader from "../../components/LogoLoader/LogoLoader";
import { GiFruitTree } from "react-icons/gi";
import { GoFileMedia } from "react-icons/go";
import { MdOutlineMessage } from "react-icons/md";
import { FaMoneyBill } from "react-icons/fa";
import { IoMdSettings } from "react-icons/io";

function AdminDashboard() {
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalActiveUsers, setTotalActiveUsers] = useState(0);

  const [companyFunds, setCompanyFunds] = useState({
    received_amount: 0,
    all_funds: 0,
  });
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // Fetch all users once
        const usersResponse = await fetch(
          `${CRUDadmin}?table=users&api_key=${API_KEY}`,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" },
          }
        );
        const usersData = await usersResponse.json();

        if (usersData.success && Array.isArray(usersData.data)) {
          const allUsers = usersData.data;
          const activatedUsers = allUsers.filter(
            (user) => user.pannel_access === "True"
          );

          setTotalUsers(allUsers.length);
          setTotalActiveUsers(activatedUsers.length);
        }

        // Fetch company funds
        const fundsResponse = await fetch(
          `${CRUDadmin}?table=companyFunds&api_key=${API_KEY}`,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" },
          }
        );
        const fundsData = await fundsResponse.json();

        if (
          fundsData.success &&
          Array.isArray(fundsData.data) &&
          fundsData.data.length > 0
        ) {
          const latestFund = fundsData.data[0];
          setCompanyFunds({
            received_amount: latestFund.received_amount || 0,
            all_funds: latestFund.All_funds || 0,
          });
        }
      } catch (error) {
        console.error("Error fetching dashboard data", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [user]);

  if (loading) {
    return <LogoLoader isLoading={true} />;
  }

  return (
    <section className="mt-2">
      <div>
        <h1 className="text-3xl font-bold text-center text-secondary">
          Dashboard
        </h1>
        <p className="text-sm text-center text-gray-200">Welcome, Admin</p>
      </div>

      <div className="grid grid-cols-2 gap-2 px-2">
        <div className="shadow-xl rounded-2xl overflow-hidden transition-transform duration-300 hover:scale-105">
          <Link to="/users">
            <div className="bg-secondary p-4 flex flex-col justify-between h-full rounded-2xl text-primary">
              <h2 className="text-[12px] sm:text-sm font-semibold flex items-center">
                <IoReceiptSharp className="text-[16px] sm:text-2xl mr-2" />
                Total Activated Users
              </h2>
              <p className="text-[30px] sm:text-xl font-extrabold">
                {totalActiveUsers}
              </p>
              <p className="text-[8px] sm:text-xs text-opacity-80">
                Users signed up in the dashboard.
              </p>
            </div>
          </Link>
        </div>

        <div className="shadow-xl rounded-2xl overflow-hidden transition-transform duration-300 hover:scale-105">
          <Link to="/users">
            <div className="bg-primary-100 p-4 flex flex-col justify-between h-full rounded-2xl text-white">
              <h2 className="text-[12px] sm:text-sm font-semibold flex items-center">
                <IoReceiptSharp className="text-[16px] sm:text-2xl mr-2" />
                Total Users
              </h2>
              <p className="text-[30px] sm:text-xl font-extrabold">
                {totalUsers}
              </p>
              <p className="text-[8px] sm:text-xs text-opacity-80">
                Users signed up in the dashboard.
              </p>
            </div>
          </Link>
        </div>
         <div className="shadow-xl rounded-2xl overflow-hidden transition-transform duration-300 hover:scale-105">
          <Link to="/admin-dashboard/app-settings">
            <div className="bg-primary-100 p-4 flex flex-col justify-between h-full rounded-2xl text-white">
              <h2 className="text-[12px] sm:text-sm font-semibold flex items-center">
                <IoMdSettings className="text-[16px] sm:text-2xl mr-2" />
                App Settings
              </h2>
             
              <p className="text-[8px] sm:text-xs text-opacity-80">
                Change your application settings.
              </p>
            </div>
          </Link>
        
         

        </div>

        <div>
           <Link to="/admin-dashboard/add-bonus">
            <div className="bg-primary-100 p-4 flex flex-col justify-between h-full rounded-2xl text-white">
              <h2 className="text-[12px] sm:text-sm font-semibold flex items-center">
                <IoMdSettings className="text-[16px] sm:text-2xl mr-2" />
                Add Bonus
              </h2>
             
              <p className="text-[8px] sm:text-xs text-opacity-80">
                Change your application settings.
              </p>
            </div>
          </Link>
        </div>
      </div>

      <p className="text-sm text-center text-gray-200 font-black mt-2">
        Quick Access
      </p>

      <div className="p-2 overflow-x-hidden space-y-2">
        <div className="grid grid-cols-2 gap-1">
          <div className="shadow-2xl  overflow-hidden transform transition duration-300 hover:scale-105">
            <Link to="/admin-dashboard/media">
              <div className="bg-primary-100 p-6 flex flex-col items-start justify-center h-full rounded-md text-white">
                <h2 className="text-sm sm:text-base font-semibold flex items-center gap-3">
                  <GoFileMedia className="text-xl sm:text-3xl" />
                  <span>Upload Media</span>
                </h2>
              </div>
            </Link>
          </div>

          <div className="shadow-2xl overflow-hidden transform transition duration-300 hover:scale-105">
            <Link to="/referal-tree">
              <div className="bg-secondary p-6 flex flex-col items-start justify-center h-full rounded-md text-primary">
                <h2 className="text-sm sm:text-base font-semibold flex items-center gap-3">
                  <GiFruitTree className="text-xl sm:text-3xl" />
                  <span>Full Tree</span>
                </h2>
              </div>
            </Link>
          </div>

          <div className="shadow-2xl overflow-hidden transform transition duration-300 hover:scale-105">
            <Link to="/admin-dashboard/reply">
              <div className="bg-secondary p-6 flex flex-col items-start justify-center h-full rounded-md text-primary">
                <h2 className="text-sm sm:text-base font-semibold flex items-center gap-3">
                  <MdOutlineMessage className="text-xl sm:text-3xl" />
                  <span>Support Reply</span>
                </h2>
              </div>
            </Link>
          </div>

          <div className="shadow-2xl overflow-hidden transform transition duration-300 hover:scale-105">
            <Link to="/admin-dashboard/all-payments">
              <div className="bg-primary-100 p-6 flex flex-col items-start justify-center h-full rounded-md text-white">
                <h2 className="text-sm sm:text-base font-semibold flex items-center gap-3">
                  <MdOutlineMessage className="text-xl sm:text-3xl" />
                  <span>All Payments</span>
                </h2>
              </div>
            </Link>
          </div>
        </div>

        <p className="text-sm text-center text-gray-200 font-black">Accounts</p>

        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
          {/* Total Company Balance */}
          <div className="shadow-xl rounded-xl overflow-hidden transform transition duration-200 hover:scale-[1.02]">
            <Link to="">
              <div className="bg-primary-100 p-4 text-white flex items-center gap-3">
                <FaMoneyBill className="text-lg sm:text-xl" />
                <div className="flex flex-col leading-tight">
                  <span className="text-xs sm:text-sm font-semibold">
                    Total Balance
                  </span>
                  <span className="text-base sm:text-lg font-bold">
                    ₹{companyFunds.all_funds}
                  </span>
                  <span className="text-[10px] sm:text-xs text-white/70">
                    Total funds received
                  </span>
                </div>
              </div>
            </Link>
          </div>

          {/* Company Profit */}
          <div className="shadow-xl rounded-xl overflow-hidden transform transition duration-200 hover:scale-[1.02]">
            <Link to="">
              <div className="bg-green-600 p-4 text-white flex items-center gap-3">
                <FaMoneyBill className="text-lg sm:text-xl" />
                <div className="flex flex-col leading-tight">
                  <span className="text-xs sm:text-sm font-semibold">
                    Company Balance
                  </span>
                  <span className="text-base sm:text-lg font-bold">
                    ₹{companyFunds.received_amount}
                  </span>
                  <span className="text-[10px] sm:text-xs text-white/70">
                    Balance funds received
                  </span>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AdminDashboard;
